export default __webpack_public_path__ + "img/0cf4fb00ca6d012678c128833678f9ba.png";